import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import SUserLayout from '@slg/web-customer-shared/src/components/layouts/userLayout/SUserLayout.vue';
import importedAppConfig from '@/appConfig';
import { useI18n, useRouteRef } from '@/composables';


const __default__ = {
  name: 'TripsPage',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18n();
const route = useRouteRef();

const tripsCount = ref<{ cancelled: number | null; past: number | null; planned: number | null }>({
  cancelled: null,
  past: null,
  planned: null,
});
const appConfig = ref<Record<string, any>>({});

appConfig.value = importedAppConfig;

const currentTabName = computed(() => route.value.name);
const sidebarItems = computed(() => [
  {
    name: `${t('trips.planned')} ${tripsCount.value.planned !== null ? `(${tripsCount.value.planned})` : ''}`,
    route: 'planned',
  },
  {
    name: `${t('trips.past')} ${tripsCount.value.past !== null ? `(${tripsCount.value.past})` : ''}`,
    route: 'past',
  },
  {
    name: `${t('trips.canceled')} ${tripsCount.value.cancelled !== null ? `(${tripsCount.value.cancelled})` : ''}`,
    route: 'canceled',
  },
]);

function updateTripsCount(count: { cancelled: number | null; past: number | null; planned: number | null }) {
  tripsCount.value = count;
}

return { __sfc: true,t, route, tripsCount, appConfig, currentTabName, sidebarItems, updateTripsCount, SUserLayout }
}

})